import axios from 'axios';

let _notified = false;

const originalCreate = axios.create.bind(axios);

// Patch axios.create so every instance gets the 401 interceptor automatically
axios.create = function (...args) {
  const instance = originalCreate(...args);
  attachInterceptor(instance);
  return instance;
};

// Also attach to the global axios instance
attachInterceptor(axios);

function attachInterceptor(instance) {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url || '';
      const authHeader = error.config?.headers?.Authorization || '';
      const isJwt = authHeader.startsWith('Bearer ');

      // Only handle JWT-authenticated requests, not login/refresh/signature-auth
      if (
        status === 401 &&
        isJwt &&
        !url.includes('/auth/login') &&
        !url.includes('/auth/refresh') &&
        !url.includes('/merchant/auth/login')
      ) {
        if (!_notified) {
          _notified = true;

          // Determine redirect target based on token storage key
          const isMerchant = !!localStorage.getItem('merchant_access_token') &&
            !localStorage.getItem('access_token');
          const loginPath = isMerchant ? '/merchant/login' : '/admin/login';

          // Show notification via ant design message if available
          try {
            const { message } = require('antd');
            message.warning('Sesi telah berakhir. Silakan login kembali.');
          } catch (_) {}

          localStorage.removeItem('access_token');
          localStorage.removeItem('user');
          localStorage.removeItem('merchant_access_token');

          setTimeout(() => {
            _notified = false;
            window.location.href = loginPath;
          }, 1500);
        }
      }

      return Promise.reject(error);
    }
  );
}
